import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';

const SharedContext = React.createContext(false);

export const SharedProvider = SharedContext.Provider;

export const SharedConsumer = SharedContext.Consumer;

export const SharedApp = withRouter(({ children, location }) => {
    const [isSharedMode] = useState(location.pathname.startsWith('/shared'));

    useEffect(() => {
        if (isSharedMode) {
            document.body.style.overflow = 'hidden';
        }
    }, [isSharedMode]);

    return (
        <SharedProvider value={isSharedMode}>
            {children}
        </SharedProvider>
    );
});

export default SharedContext;
